/**
 * 안전관리 서약서 서명 모달 (BS self-contained)
 *
 * 호출:
 *   $j.Ui.BS.open({
 *       target: '$j.F.Member.ModalSafetySign',
 *       data: {
 *           $p: { w, h },              // 캔버스 사이즈 등 입력
 *           onApply: ($r) => { ... }   // 서명 완료 콜백
 *       }
 *   });
 *
 * BS가 this.id, this.parent, this.data 를 주입한 후 init() 호출.
 */
import Util from '../../../Common/Util';
export default class SafetySign {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.signaturePad = null;
        this.canvas = null;
        this.ctx = null;
        this.isSaving = false;
    }

    init() {
        // 입력 정규화
        if (!this.data) this.data = {};
        if (!this.data.$p) this.data.$p = {};
        this.data.$r = {};

        // skeleton 동기 렌더링
        const w = this.data.$p['w'] || 0;
        const h = this.data.$p['h'] || 0;
        $('#' + this.id).html(this.skeletonHtml(w, h));

        this._setupCanvas();
        this._bindHandlers();
    }

    skeletonHtml(width, height) {
        return `
<div class="safety_sign_wrap">
    <h2 class="modal_title">서명하기</h2>

    <div class="flex_column modal_content">
        <div class="sign_area">
            <canvas id="signature-pad" class="signature-pad" width="${width}" height="${height}"></canvas>
        </div>
        <div class="sign_btn_container flex">
            <div class="modal_button flex">
                <button type="button" class="sign_btn reset-btn">초기화</button>
            </div>
            <div class="modal_button flex">
                <button type="button" class="sign_btn apply-btn">서명완료</button>
            </div>
        </div>
    </div>
</div>`;
    }

    destroy() {
        $('#' + this.id).off();
    }

    _setupCanvas() {
        this.canvas = document.getElementById('signature-pad');
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext('2d');
        this.signaturePad = new SignaturePad(this.canvas, {
            minWidth: 0.5,
            maxWidth: 2.5,
            backgroundColor: 'rgba(0, 0, 0, 0)',
        });
    }

    _bindHandlers() {
        const self = this;
        const $root = $('#' + this.id);

        $root.on('click.safety', '.pen-btn',   () => self.pen());
        $root.on('click.safety', '.reset-btn', () => self.reset());
        $root.on('click.safety', '.apply-btn', () => self.apply());
        $root.on('click.safety', '.close_btn', () => self.parent.close());
    }

    /**
     * 기존 서명 이미지 로드 (재서명 시)
     * TODO : CORS 문제를 해결해야함
     */
    load(imgurl) {
        if (!imgurl || !this.signaturePad) return;
        const self = this;
        const img = new Image();
        img.onload = function () {
            self.ctx.drawImage(img, 0, 0, self.canvas.width, self.canvas.height);
            self.signaturePad.fromDataURL(self.canvas.toDataURL());
        };
        img.src = imgurl;
    }

    pen() {
        $('#sign_button_erase').removeClass('on');
        $('#sign_button_draw').removeClass('on').addClass('on');
        this.signaturePad.minWidth = 1;
        this.signaturePad.maxWidth = 5;
        this.signaturePad.compositeOperation = 'source-over';
    }

    erase() {
        $('#sign_button_erase').removeClass('on').addClass('on');
        $('#sign_button_draw').removeClass('on');
        this.signaturePad.minWidth = 10;
        this.signaturePad.maxWidth = 10;
        this.signaturePad.compositeOperation = 'destination-out';
    }

    reset() {
        if (this.signaturePad) this.signaturePad.clear();
    }

    apply() {
        if (this.getStrokeCount() === 0) {
            Util.swalert('서명을 하지 않았습니다.');
            return;
        }
        if (this.isSaving) return;
        this.isSaving = true;

        $('.reset-btn').parent().hide();
        $('.apply-btn').html('처리중..');

        this.data.$r['sign_data'] = this.signaturePad.toDataURL('image/png');

        const cb = this.data?.onApply;
        this.parent.close();
        if (typeof cb === 'function') cb(this.data.$r);
    }

    getStrokeCount() {
        if (!this.signaturePad) return 0;
        const strokes = this.signaturePad.toData();
        let count = 0;
        for (let i = 0; i < strokes.length; i++) {
            if (strokes[i].points.length > 0) count++;
        }
        return count;
    }

    /**
     * 서명 요청 취소 (외부에서 직접 호출되는 정적 액션 - 모달 인스턴스와 무관)
     * @param ordernum 오더번호
     * @param odr 순서
     */
    cancel(ordernum, odr) {
        const sendData = { ordernum, odr };
        Util.swalert(
            [`<h2>원격서명 요청을 취소하시겠습니까?</h2></br><p>다른 분께 서명을 받으시거나 원격요청 재발송 시
취소 후 진행하셔야 합니다.</p>`],
            () => {
                $.ajax({
                    type: 'post',
                    url:  '/m/ajax/sign/order/cancel',
                    data: sendData,
                    success(data) {
                        if (data.result) $('.wait_overlay').hide();
                        else alert('요청 취소에 실패했습니다.');
                    },
                });
            },
            ['요청취소', '취소'],
        );
    }
}
